<div *ngIf="!editarProductoDesembolso && !verDetalle">
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
      <button type="button" pButton icon="fa fa-plus" (click)="crear()"
              label="{{ 'BTN_AGREGAR' | translate}}"></button>
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="productosDesembolsos" selectionMode="single" dataKey="idProducto"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center"
                [attr.colspan]="col.colspan" [attr.rowspan]="col.rowspan">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
          <tr>
            <th *ngFor="let col of columnas2" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center"
                [attr.colspan]="col.span">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.rangoMontoAprobadoMinimo}}</td>
            <td>{{row.rangoMontoAprobadoMaximo}}</td>
            <td>{{row.rangoPlazoAprobadoMinimo}}</td>
            <td>{{row.rangoPlazoAprobadoMaximo}}</td>
            <td>{{row.rangoTasaProductoMinimo}}</td>
            <td>{{row.rangoTasaProductoOrdinario}}</td>
            <td>{{row.limiteDiaDesembolso}}</td>
            <td>{{row.minimoDiaCantidadDesembolsoParcial}}</td>
            <td>{{row.maximoDiaCantidadDesembolsoParcial}}</td>
            <td>{{row.rangoAmpliarPlazoMinimoDia}}</td>
            <td>{{row.rangoAmpliarPlazoMaximoDia}}</td>
            <td>{{row.ampliarPlazo}}</td>
            <td>{{row.diaMaximoMoraCliente}}</td>
            <td>{{row.diaMaximoMoraProducto}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                        title="{{'BTN_VISUALIZAR' | translate}}"
                        pButton (click)="ver(row)"></button>
                <button type="button" class="p-button btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}"
                        pButton (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Detalle Producto Desembolso -->
<app-producto-desembolso-detalle (dismiss)="ocultarDetalle($event)"
                                 [productoDesembolso]="productoDesembolsoEdit"
                                 *ngIf="verDetalle">
</app-producto-desembolso-detalle>

<!-- Editar Producto Desembolso -->
<app-producto-desembolso-editar (dismiss)="ocultarDetalle($event)"
                                [rangoMontoAprobado]="rangosMontosAprobados"
                                [productoDesembolso]="productoDesembolsoEdit"
                                *ngIf="editarProductoDesembolso">
</app-producto-desembolso-editar>
